export const apiURL = {
  auth: {
    login: '/api/v1/auth/login',
    logout: '/api/v1/auth/logout',
    registerBrand: '/api/v1/auth/register/brand',
    registerInfluencer: '/api/v1/auth/register/influencer',
    verifyUser: '/api/v1/auth/verify',
    verifyLink: (vid, id) => `/api/v1/auth/verify/${vid}/${id}`,
    generateVerify: id => `/api/v1//auth/generate-verify/${id}`,
    forgotPassword: '/api/v1//auth/password-change'
  },
  brands: {
    getBrands: `/api/v1/brand/list`,
    update: id => `/api/v1/brand/${id}`,
    getById: id => `/api/v1/brand/${id}`
  },
  admins: {
    getAll: '/api/v1/admin'
  },
  users: {
    get: role => `/api/v1/${role}`
  },
  influencers: {
    getInfluencerById: id => `/api/v1/influencer/${id}`,
    getInfluencerCampaign: id => `/api/v1/influencer/${id}/campaign`
  },
  campaigns: {
    getCampaigns: '/api/v1/campaign',
    getCampaignById: id => `/api/v1/campaign/${id}`,
    createCampaign: '/api/v1/campaign',
    updateCampaign: id => `/api/v1/campaign/${id}`,
    setProposal: id => `/api/v1/proposal/${id}`,
    proposalAction: (id, action) => `/api/v1/proposal/${id}/${action}`,
    campaignAction: (id, action) => `/api/v1/campaign/${id}/${action}`,
    addInfluencer: id => `/api/v1/campaign/${id}/add`,
    removeInfluencer: id => `/api/v1/campaign/${id}/remove`
  },
  chats: {
    getChats: '/api/v1/chat',
    getRooms: '/api/v1/room'
  },
  csv: { default: '/api/v1/csv', influencers: '/api/v1/csv-influencers' },
  comments: {
    main: '/api/v1/comments'
  },
  settings: '/api/v1/settings'
}
